import { IMallOrderDetail } from './type'
import { get } from '@/utils'
import React from 'react'
import fengniaoIcon from '@/assets/images/fengniaoIcon.svg'

export function getCompanyname(type: string) {
    switch (type) {
        case 'ne66':
            return '安能快递'
        case 'debangkuaidi':
            return '德邦快递'
        case 'ems':
            return 'EMS'
        case 'guotongkuaidi':
            return '国通快递'
        case 'huitongkuaidi':
            return '百世快递'
        case 'jd':
            return '京东物流'
        case 'kuayue':
            return '跨越速运'
        case 'pjbest':
            return '品骏快递'
        case 'shentong':
            return '申通快递'
        case 'shunfeng':
            return '顺丰快递'
        case 'suer':
            return '速尔快递'
        case 'xinfengwuliu':
            return '信丰物流'
        case 'youshuwuliu':
            return '优速物流'
        case 'youzhengguonei':
            return '邮政快递包裹'
        case 'yuantong':
            return '圆通速递'
        case 'yuantongguoji':
            return '圆通国际'
        case 'yunda':
            return '韵达快递'
        case 'zhaijisong':
            return '宅急送'
        case 'zhongtong':
            return '中通快递'
        case 'ewe':
            return 'EWE全球快递'
        case 'quanyikuaidi':
            return '全一快递'
        case 'jtexpress' :
            return '极兔速递'
        default:
            return '未知'
    }
}

const showSearchPackage = (order: IMallOrderDetail.Extras) => {
    const url = `https://www.kuaidi100.com/chaxun?nu=${order.tracking_number}&com=${order.express_company}`
    window.open(url)
}

export const getOrderStatus = (record: IMallOrderDetail.OrderOperateRecord) => {
    const operatorRealName = `${get(record.operator_staff, ['user', 'realname'], '')}·`

    const renderRefund = () => <div>{`${operatorRealName}已退款`}</div>

    switch (record.operation) {
        case -30000:
            return '超时未支付，订单自动取消'
        case -20000:
            return '用户已取消'
        case -10000:
            return '商家已取消'
        case 0:
            return '订单已提交'
        case 10000:
            return '支付成功'
        case 15000:
            return '待成团'
        case 20000:
            if (record.order_type === 3) {
                if (record.operator_staff.id) {
                    return `${record.operator_staff.user.realname}-强制成团，商家已接单`
                }

                return '已成团'
            } else {
                return '商家已接单'
            }
        case 20010:
            return <span>{operatorRealName}更改配送信息</span>
        case 30000:
            return <span>{operatorRealName}已通知用户提货</span>
        case 40000:
            return <span>{operatorRealName}直送商品</span>
        case 40001:
            return (
                <div className="row fx-v-center">
                    <img src={fengniaoIcon} className="width-20 height-20" alt="" />
                    <span className="font-size-12">{operatorRealName}商品已安排配送</span>
                </div>
            )
        case 40002:
            return (
                <div className="row fx-v-center">
                    <img src={fengniaoIcon} className="width-20 height-20" alt="" />
                    <span className="font-size-12">{operatorRealName}骑手已接单</span>
                </div>
            )
        case 40003:
            return (
                <div className="row fx-v-center">
                    <img src={fengniaoIcon} className="width-20 height-20" alt="" />
                    <span className="font-size-12">{operatorRealName}骑手已到店</span>
                </div>
            )
        case 40004:
            return (
                <div className="row fx-v-center">
                    <img src={fengniaoIcon} className="width-20 height-20" alt="" />
                    <span className="font-size-12">{operatorRealName}骑手配送中</span>
                </div>
            )
        case 40005:
            return (
                <div className="row fx-v-center">
                    <img src={fengniaoIcon} className="width-20 height-20" alt="" />
                    <span className="font-size-12">{operatorRealName}骑手已送达</span>
                </div>
            )
        case 40050:
            return <span>{operatorRealName}商品已送出</span>
        case 50000:
            return (
                <p className="font-size-12 color-333">
                    <span>物流已发货，</span>
                    <span>{getCompanyname(record.extras.express_company || '')}</span>
                    <span onClick={() => showSearchPackage(record.extras)} className="action margin-left-5">
                        {record.extras.tracking_number.slice(0, 3)}***
                        {record.extras.tracking_number.slice(-3)}
                        <i className="iconfont icon6sousuo999-20 font-size-12 margin-left-2"></i>
                    </span>
                </p>
            )
        case 50010:
            return (
                <p className="font-size-12 color-333">
                    <span>快递已揽件，</span>
                    <span>{getCompanyname(record.extras.express_company)}</span>
                    <span onClick={() => showSearchPackage(record.extras)} className="action margin-left-5">
                        {record.extras.tracking_number.slice(0, 3)}***
                        {record.extras.tracking_number.slice(-3)}
                        <i className="iconfont icon6sousuo999-20 font-size-12 margin-left-2"></i>
                    </span>
                </p>
            )
        case 50020:
            return (
                <p className="font-size-12 color-333">
                    <span>运输中，</span>
                    <span>{getCompanyname(record.extras.express_company)}</span>
                    <span onClick={() => showSearchPackage(record.extras)} className="action margin-left-5">
                        {record.extras.tracking_number.slice(0, 3)}***
                        {record.extras.tracking_number.slice(-3)}
                        <i className="iconfont icon6sousuo999-20 font-size-12 margin-left-2"></i>
                    </span>
                </p>
            )
        case 50030:
            return (
                <p className="font-size-12 color-333">
                    <span>派件中，</span>
                    <span>{getCompanyname(record.extras.express_company)}</span>
                    <span onClick={() => showSearchPackage(record.extras)} className="action margin-left-5">
                        {record.extras.tracking_number.slice(0, 3)}***
                        {record.extras.tracking_number.slice(-3)}
                        <i className="iconfont icon6sousuo999-20 font-size-12 margin-left-2"></i>
                    </span>
                </p>
            )
        case 50040:
            return (
                <p className="font-size-12 color-333">
                    <span>已签收，</span>
                    <span>{getCompanyname(record.extras.express_company)}</span>
                    <span onClick={() => showSearchPackage(record.extras)} className="action margin-left-5">
                        {record.extras.tracking_number.slice(0, 3)}***
                        {record.extras.tracking_number.slice(-3)}
                        <i className="iconfont icon6sousuo999-20 font-size-12 margin-left-2"></i>
                    </span>
                </p>
            )
        case 50050:
            return (
                <p className="font-size-12 color-333">
                    <span>已拒签，</span>
                    <span>{getCompanyname(record.extras.express_company)}</span>
                    <span onClick={() => showSearchPackage(record.extras)} className="action margin-left-5">
                        {record.extras.tracking_number.slice(0, 3)}***
                        {record.extras.tracking_number.slice(-3)}
                        <i className="iconfont icon6sousuo999-20 font-size-12 margin-left-2"></i>
                    </span>
                </p>
            )
        case 50060:
            return (
                <p className="font-size-12 color-333">
                    <span>已退回，</span>
                    <span>{getCompanyname(record.extras.express_company)}</span>
                    <span onClick={() => showSearchPackage(record.extras)} className="action margin-left-5">
                        {record.extras.tracking_number.slice(0, 3)}***
                        {record.extras.tracking_number.slice(-3)}
                        <i className="iconfont icon6sousuo999-20 font-size-12 margin-left-2"></i>
                    </span>
                </p>
            )
        case 60000:
            return '用户已提货，订单完成'
        case 70000:
            return '已送达，订单完成'
        case 70010:
            return (
                <span>
                    {operatorRealName}
                    {record.order && record.order.is_shipping ? '客户已确认收货' : '订单已一键完成'}
                </span>
            )
        case 80000:
            return renderRefund()
        case 80010:
            return '成团失败自动退款'
        case 90000:
            return '申请退款'
        case 100000:
            return renderRefund()
        case 110000:
            return '拒绝退款'
        case 20007:
            return '顾客已补款'
        case 20005:
            return `${operatorRealName}配货完成`
        case 50100:
            return `${operatorRealName}撤回至“待处理”状态`
        default:
            return '未知类型'
    }
}
